import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import DataSource from 'devextreme/data/data_source';
import _ from 'lodash';

@Component({
    selector: 'app-part-instock-overview',
    templateUrl: './part-instock-overview.component.html',
    styleUrls: ['./part-instock-overview.component.scss'],
    standalone: false
})
export class PartInStockOverviewComponent implements OnInit {
    uow = inject(GenesisUnitOfWork);
    sessionInfo = inject(SessionInformationService);
    appInfo = inject(AppInformationService);

    filter: { startDate?: Date; endDate?: Date; partId?: number; includeDeleted?: boolean } = {};
    partIds: number[];

    orderLineDetailParts: any[];
    purchaseOrderLineReceivings: any[];
    inventoryAdjustments: any[];
    partNumbers: string[];
    partNumbersDS: DataSource;

    async ngOnInit() {
        await this.appInfo.pleaseWaitShow();
        this.filter = this.sessionInfo.getItem('part-instock-filter') ?? {};
        this.partNumbers = await this.uow.getParts();
        this.partNumbersDS = new DataSource({ store: this.partNumbers, paginate: true });
        await this.appInfo.pleaseWaitHide();
    }

    async search() {
        if (!this.filter || (!this.filter.startDate && !this.filter.endDate && !this.filter.partId)) return;

        await this.appInfo.pleaseWaitShow();
        this.orderLineDetailParts = [];
        this.purchaseOrderLineReceivings = [];
        this.inventoryAdjustments = [];
        await this.getOrderLineDetailParts();
        await this.getPurchaseOrderLineReceivings();
        await this.getPartPurchaseInfos();
        this.sessionInfo.setItem('part-instock-filter', this.filter);
        await this.appInfo.pleaseWaitHide();
    }

    async getOrderLineDetailParts() {
        this.orderLineDetailParts = await this.uow.getOrderLineDetailPartInfos(this.filter.startDate, this.filter.endDate, this.filter.partId, this.filter.includeDeleted);
    }

    selectionChange = async (e) => {
        const orderLineDetailParts = e.selectedRowsData as any[];
        this.partIds = _(orderLineDetailParts).map('partId').uniq().valueOf();
        if (this.partIds.length > 100) {
            this.appInfo.notifyToast('Too many parts selected. Limiting purchases and receivings for first 100 parts', 'warning');
            this.partIds = _(this.partIds).take(100).valueOf();
        }
        if (this.partIds && this.partIds.length > 0) {
            await this.getPurchaseOrderLineReceivings();
            await this.getPartPurchaseInfos();
        } else {
            this.purchaseOrderLineReceivings = [];
            this.inventoryAdjustments = [];
        }
    };

    async getPurchaseOrderLineReceivings() {
        this.purchaseOrderLineReceivings = await this.uow.getPurchaseOrderLineReceivingInfos(this.filter.startDate, this.filter.endDate, this.filter.partId);
    }

    async getPartPurchaseInfos() {
        this.inventoryAdjustments = await this.uow.getPartPurchaseInfos(this.filter.startDate, this.filter.endDate, this.filter.partId);
    }

    clear() {
        this.filter = {};
        this.orderLineDetailParts = [];
        this.purchaseOrderLineReceivings = [];
        this.inventoryAdjustments = [];
        this.sessionInfo.removeItem('part-instock-filter');
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarTextBefore',
                location: 'before',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }
}
